import { TemplatesCategory } from './interfaces';

export const ONE_TIME_CAMPAIGNS_LIMIT = 10;
export const TEMPLATE_CATEGORIES = Object.values(TemplatesCategory);
